/**
 * SuctionBootsTile - Collectible powerup that resists arrow tiles
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class SuctionBootsTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `suctionboots-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.SUCTION_BOOTS;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/suction-boots.png" };
  }

  clone(): SuctionBootsTile {
    const copy = new SuctionBootsTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "suctionBoots", id: this.id, col: this.col, row: this.row };
  }
}
